import { ACTION_TYPES } from '@/actions';

const INIT_STATE = {
  orderInfo: {}
};

export default function orderRefund(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.CLEAR_ORDER_REFUND:
      result = INIT_STATE;
      break;
    case ACTION_TYPES.GET_ORDER_REFUND_DETAIL:
      result.orderInfo = payload;
      break;
    default:
      result = state;
  }
  return result;
}
